jQuery(function () {
    // set up padding formats for spinner
    if (!window.Globalize) window.Globalize = {
        format: function (number, format) {
            number = String(this.parseFloat(number, 10) * 1);
            format = (m = String(format).match(/^[nd](\d+)$/)) ? m[1] : 2;
            for (i = 0; i < format - number.length; i++)
                number = '0' + number;
            return number;
        },
        parseFloat: function (number, radix) {
            return parseFloat(number, radix || 10);
        }
    };
    $.qformDialog = function (viewQFormUrl, loadDataUrl, options) {
        // Create DIV and dialog for qform
        
        var newDialog = $("<div></div>").addClass('qformDialogPanel').appendTo($(document.body));
        newDialog.dialog({
            modal: true,
            closeOnEscape: false,
            draggable: true,
            resizable: false,
            width: 747,
            height: 480,
            position: 'center',
            title: unescape(options.title),
            buttons: { 'Close': function() { $(this).dialog('close'); } }
        });
        viewQFormUrl = $.buildUrl(viewQFormUrl, { formId: options.formId });
        newDialog.attr('ajaxUrl', viewQFormUrl);
        newDialog.data('qformOptions', options);
        // Add loading HTML
        newDialog
            .html('<div class="ui-loading"><div><img src="content/images/toolloading.gif" /></div><h3>Loading - please wait</h3></div>');

        var getButtons = function(qform) {
            var buttons = {};
            if (!qform.isReadonly || qform.isReadonly == '0') {
                if (qform.isDirty == '-1')
                    qform.isDirty = '0';
                if (qform.isDirty == '0') {
                    buttons['Close'] = function() { qform.closeDialog(); };
                    buttons['Submit'] = function() { qform.submitForm('submit'); };
                    buttons['Save Draft'] = function() {
                        $.showLoadingSpinner();
                        qform.submitForm('save');
                       
                    };
                    
                    if (options.disablePrint !== true && (options.id || qform.formId) && qform.isNew === 0 && !qform.customButtons.filter(function(b) {return b.text === "Print"}).length) {
                        buttons['Print'] = function() { printEreport(options.id); };
                    }
                } else {
                    buttons['Cancel'] = function() { qform.resetForm(); };
                    buttons['Submit'] = function() {
                        qform.submitForm('submit');
                    };
                    buttons['Save Draft'] = function() {
                        qform.submitForm('save');
                       
                    };
                    
                    if (options.disablePrint !== true && (options.id || qform.formId) && qform.isNew === 0 && !qform.customButtons.filter(function(b) {return b.text === "Print"}).length) {
                        buttons['Print'] = function() { printEreport(options.id); };
                    }
                }
            } else {
                qform.isDirty = '-1';
                buttons['Close'] = function () { qform.closeDialog(); };
                if (!options.disablePrint)
                   buttons['Print'] = function() { printEreport(options.id); };
            }
            return buttons;
        };
        var loadHtml = function(response) {
            newDialog.html(response);
            var dialogHelper = new $.qFormDialogHelper(newDialog,
            {
                resetMessage:
                    'This form will be restored to its original state and all changes will be lost.<br />Do you want to continue?',
                resetTitle: 'Are you sure?',
                errorMessage: 'The following errors must be fixed before you can save the form:',
                errorTitle: 'Could not save form.',
                getButtons: getButtons
            });
            var loadOptions = { merge: options.merge, formId: options.formId };
            if (options.id)
                loadOptions.id = options.id;

            $.get($.buildUrl(loadDataUrl, loadOptions), dialogHelper.initialLoad);

        };
        if (options.formData) {
            $.post(viewQFormUrl, options.formData, loadHtml);
        } else {
            $.get(viewQFormUrl, loadHtml);
        }
        return newDialog;
    };
});

 function convertDateFormat(dateFormat) {
    //convert the format string to match the formats in the ui.datepicker.js - search for DATEPICKERFORMATS

  var x = dateFormat.replace(/mmmm/g, 'MM').replace(/mmm/g, 'M').replace(/nn/g, 'II').replace(/H/g, 'HH').replace(/hh/g, 'HH').replace(/HHHH/g,'HH').replace(/yy/g, 'y');
    return x;
}
function convertDateFormatToFlatpickr(dateFormat) {
    //convert the format string to match the formats in the flatpickr - see PHP's Date formatting
    var replacements = { "nn": "i", "n": "i", "AM/PM": "A", "am/pm": "a", "A/P": "A", "a/p": "a", "dddd": "l", "ddd": "D", "dd": "d", "d": "j", "mmmm": "F", "mm": "m", "mmm": "M", "m": "n", "yyyy": "Y", "yy": "y", "tt": "A", "h": "g", "H": "H", "hh": "H", "ss": "s", "zzz": "P" };

    var newFormat = dateFormat.replace(/\b([dmyhmsnapt]+)\b/gi,
      function (match) {
        return replacements[match] || match;
      });
    newFormat = newFormat.replace(/\b([a\/p]+)\b/gi,
      function (match) {
        return replacements[match] || match;
      });
    // Check for a/A and convert 24hour time to 12
    if (newFormat.indexOf('a') > 0 || newFormat.indexOf('A') > 0)
        newFormat = newFormat.replace('H', 'h');
    return newFormat;
}
function getPath() {
	//have to derive the path from the window as we have no context
	var pathArray = window.location.pathname.split('/');
	newPathname = "";
	for (i = 0; i < pathArray.length - 1; i++) {
		newPathname += pathArray[i];
		newPathname += "/";
	}
	return newPathname;
}
function getTimeFormatComponents(format) {
	var components = [];
	var prevToken = '';
	for (var i in format) {
		if (prevToken == format[i]) {
			components[components.length - 1] += format[i];
		} else {
			components.push(format[i]);
		}

		prevToken = format[i];
	}
	return components;
}

function createTimePicker(id, format) {
	var obj = $('input[name="' + id + '"]');
	if (obj.length == 0)
		throw new Error('Input[name="' + id + '"] not found');
	

	var formatComponents = getTimeFormatComponents(format);
	var div = $('<div></div>').attr('style', obj.attr('style')).appendTo(obj.parent());
	obj.attr('type', 'hidden');
	div.css('border', '1px solid #cccecf');
	div.css('display', 'flex');
	div.addClass('time-container');
	div.attr('id', obj.attr('id') + "_timecontainer");
	obj.attr('linkedto', obj.attr('id') + "_timecontainer");
	obj.appendTo(div);
	var getHours = function (div) {
		var hours = $(div).find('.hour').val();
		if (hours == "")
			return "";
		if ($(div).find('.hour').attr('data-component').indexOf('H') >= 0) {
			return hours;
		}
		// 12 hour time
		var ampm = $(div).find('.ampm').val();
		if (ampm == "pm" && hours != "12") hours = parseFloat(hours) + 12;
		if (ampm == "am" && hours == "12") hours = 0;
		return hours;
	};
	var getMinutes = function (div) {
		var mins = $(div).find('.min').val();
		return mins;
	};
	var updateDisplayFields = function() {

	};
	obj.on('change',
		function () {
			
			var hoursMins = $(this).val().split(':');
			if (hoursMins.length == 2) {
				if ($(div).find('.hour').attr('data-component').indexOf('H') >= 0) {
					div.find('.hour').val(hoursMins[0]);
				} else if (hoursMins[0].length) {
					var hour24 = parseFloat(hoursMins[0]);

					if (div.find('.ampm')) {
						div.find('.ampm').find('option').remove();
						$('<option></option>').val('am').text('AM').appendTo(div.find('.ampm'));
						$('<option></option>').val('pm').text('PM').appendTo(div.find('.ampm'));
					}
					if (hour24 > 12) {
						div.find('.ampm').val('pm');
						hour24 = hour24 - 12;
					} else if (hour24 == 0) {
						div.find('.ampm').val('am');
						hour24 = 12;
					} else if (hour24 == 12) {
						div.find('.ampm').val('pm');
					}
					div.find('.hour').val(hour24);
				}
				div.find('.min').val(hoursMins[1]);

				if (div.find('.min').val().toString().length < div.find('.min').attr('data-component').length) {
					div.find('.min').val("0" + div.find('.min').val().toString());
				} if (div.find('.hour').val().toString().length < div.find('.hour').attr('data-component').length) {
					div.find('.hour').val("0" + div.find('.hour').val().toString());
				}
			} else {
				div.find('.hour').val('');
				div.find('.min').val('');
			}
		});
	var updateHiddenField = function () {
		var newtime = getHours(div) + ":" + getMinutes(div);
		
		$(obj).val(newtime != ":" ? newtime : "");
	};
	// Define 24 hour time vs 12 hour
	for (var i in formatComponents) {
		var component = formatComponents[i];
		var min = 0;
		var max = 59;
		var type = '';
		var amLabel = '';
		var pmLabel = '';
		if (component.indexOf('h') >= 0) {
			min = 1;
			max = 12;
			type = 'hour';
		}
		if (component.indexOf('H') >= 0) {
			min = 0;
			max = 23;
			type = 'hour';
		} if (component.indexOf('m') >= 0) {
			min = 0;
			max = 59;
			type = 'min';
		} if (component.indexOf('t') >= 0) {
			type = 'ampm';
			amLabel = 'AM';
			pmLabel = 'PM';
		}
		var el = null;
		if (type == 'min' || type == 'hour') {
			el = $('<input type="number" class="hideSpinner time-component"  />');
		} else if (type == 'ampm') {
			el = $('<select class="time-component"></select>');
			$('<option></option>').val('am').text(amLabel).appendTo(el);
			$('<option></option>').val('pm').text(pmLabel).appendTo(el);
		} else {
			el = $("<span></span>").text(component);
		}
		el.attr('min', min).attr('max', max).attr('data-type', type).addClass(type).attr('data-component', component).appendTo(div);

		// Now add validations etc
		if (type != '' && type != 'ampm') {
			el.on('change',
				function() {
					var val = $(this).val();
					var floatVal = parseFloat(val);
					if (val != "" && floatVal > parseFloat($(this).attr('max'))) {
						if ($(this).is('.hour')) {
							// Assume user wanted to enter minutes
							$(this).val(val.substring(0, val.length - 1));
							
							$(this).parent().find('.min').focus();
							$(this).parent().find('.min').val(val.substring(val.length - 1));
							val = $(this).val();
						} else {
							$(this).val($(this).attr('max'));
						}
					}
					if (val != "" && floatVal < parseFloat($(this).attr('min'))) {
						$(this).val($(this).attr('min'));
					}
					if (val.toString().length > 0 && val.toString().length < $(this).attr('data-component').length) {
						$(this).val("0" + val);
					}
					var finalVal = $(this).val();
					updateHiddenField();
				});
		} else if (type == 'ampm') {
			el.on('change', function() {
				updateHiddenField();

			});
		}
		el.on('keyup', function (e) {
			if (e.keyCode == 186) // Is colon
			{
				var next = $(this).next();
				if (next.length && !next.is('input,select'))
					next = next.next();
				if (next.length)
					next.focus();
			}
			if (((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) && $(this).val().length > 1 && $(this).is('input')) {
				var selection = window.getSelection();
				var currentSelectionLength = selection.toString().length;
				selection.modify('extend', 'forward', 'character');
				if (currentSelectionLength != selection.toString().length) {
					// Not end of input, so cancel
					selection.modify('extend', 'backward', 'character');
					return;
				}
					var next = $(this).next();
					if (next.length && !next.is('input,select'))
						next = next.next();
					if (next.length)
						next.focus();
				}
			});
		el.on('keydown',
			function (e) {
				
				
				if (e.keyCode === 37 /*Left*/ || e.keyCode === 8 /*Backspace*/) {
					var selection = window.getSelection();
					var currentSelectionLength = selection.toString().length;
					selection.modify('extend', 'backward', 'character');
					if (currentSelectionLength != selection.toString().length) {
						// Not begingging of input, so cancel
						selection.modify('extend', 'forward', 'character');
						return;
					}
					// focus previous component
					var prev = $(this).prev();
					if (prev.length && !prev.is('input,select'))
						prev = prev.prev();
					if (prev.length)
						prev.focus();
					e.preventDefault();

				}
				if (e.keyCode === 39 /*Right*/ || e.keyCode === 46 /*Delete*/) {
					var selection = window.getSelection();
					var currentSelectionLength = selection.toString().length;
					selection.modify('extend', 'forward', 'character');
					if (currentSelectionLength != selection.toString().length) {
						// Not end of input, so cancel
						selection.modify('extend', 'backward', 'character');
						return;
					}
						// focus previous component
					var next = $(this).next();
					if (next.length && !next.is('input,select'))
						next = next.next();
						if (next.length)
							next.focus();
					e.preventDefault();
				}
			});
	}

} 


function createDatePicker(id) {
  //  try {
    var obj = $('input[name="' + id + '"]');
		if (obj.length == 0)
			throw new Error('Input[name="' + id + '"] not found');
		var format = $(obj).attr('format');
		if (format == undefined || format == "" || format == null) {
			$(obj).attr('format', "yyyy-mm-dd HH:nn"); // yyyy-mm-dd HH:nn
			format = $(obj).attr('format');
    }
    var convertedDateformat = convertDateFormatToFlatpickr(format);
    $(obj).attr('data-date-format', convertedDateformat);
  //console.log("CONVERTED",format,convertedDateformat);
		var initialValue = $(obj).val();
		$(obj).val('');
  $(obj).attr('disabled', 'disabled');
		var flatpickr = $(obj).flatpickr({
		    changeMonth: true, changeYear: true,
        "allowInput": true,
        time_24hr: convertedDateformat.indexOf('H') > -1,
		    aqdDateFormat: format,
		    minuteIncrement:1,
		    parseDate: function (v) {
		        if (v == null || v == "")
		            return false;
            return $.datepicker.parseDate(convertDateFormat(format), v);
		    },
		   
		    defaultDate: "",
		    
		    onClose: function (dateObj, dateStr, instance) {
		        window.setTimeout(function () {
		            dateStr = $(obj).val();
		            try {
		                if (dateStr == null || dateStr == "") {
		                    instance.setDate(false);
		                    window.setTimeout(function () { $(obj).trigger('blur'); }, 100);
		                }
		                if (dateStr && dateObj != $.datepicker.parseDate(convertDateFormat(format), dateStr)) {

		                    instance.setDate($.datepicker.parseDate(convertDateFormat(format), dateStr));
		                    window.setTimeout(function() { $(obj).trigger('blur'); }, 100);
		                }
		            } catch (ex) {
		            }
		        },100);
		    },
			enableTime: (format.indexOf('H') + format.indexOf('h')) >= 0, dateFormat: convertDateFormatToFlatpickr(format)
		});
        $(obj)
            .change(function() {

                if ($(this).val() == '') {
                    var flatpickr = $(this).getFlatpickr();

                    flatpickr.selectedDates = [];
                    flatpickr.input.value = '';
                    flatpickr.redraw();


                }

            });
    
    var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		if (isNaN(msie)) {
		    msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		}

		if ((!isNaN(msie) && msie > 0) || /Edge\/\d./i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent)) {
		    $('.flatpickr-hour')
		        .spinner({
		            max: 23,
		            min: 0,
		            spin: function(event, ui) {
		                $(this).change(); var selectedDay = $(this).parents('.flatpickr-calendar').find('.flatpickr-day.selected');
		                if (selectedDay.length == 0)
		                    selectedDay = $(this).parents('.flatpickr-calendar').find('.flatpickr-day.today');
		                window.setTimeout(function () {
		                    selectedDay.click();
		                },
                        50);
		            }
		        });
		    $('.flatpickr-minute').spinner({
		        max: 59, min: 1, numberFormat: "d2", spin: function (event, ui) {
		            $(this).change();
		            var selectedDay = $(this).parents('.flatpickr-calendar').find('.flatpickr-day.selected');
		            if (selectedDay.length == 0)
		                selectedDay = $(this).parents('.flatpickr-calendar').find('.flatpickr-day.today');

		            window.setTimeout(function () {
		               selectedDay.click();
		            },
		            50);
		        }
        });
		    $('.cur-year').spinner({
		      spin: function(event, ui) {


            
            $('.flatpickr-input.active')[0]._flatpickr.currentYear = ui.value;
            $('.flatpickr-input.active')[0]._flatpickr.redraw();
		        

		      }
		    }).change(function(e) { $(this).trigger('input', e); });
		  
		}
		if (initialValue) {
		    var dateObj = Date.parseISO(initialValue) || $.datepicker.parseDate(convertDateFormat(format), initialValue);
		    flatpickr.setDate(dateObj);
		}
    var occurrencedatefield = $(obj);
		var occurrenceutcfield = $('input[fieldId=23]');
		if (occurrenceutcfield.length == 0)
		    occurrenceutcfield = $('div[fieldId=23] >*:first');
	    
	    if ($(obj).attr('fieldid') == '22') {

	        
	        if (occurrenceutcfield.length == 0)
	            occurrenceutcfield = $('div[fieldId=23] >*:first');
	        $(obj).bind('updateValue', function(ev,value) {
	            // Always sent as UTC
	            $(this).datepicker('setDate', convertDate(value,'UTC',occurrenceutcfield.val()));

	        });
	        
	        var dp = $(obj);
	        $(document).bind('setFieldID23', function (ev, data) {
	            
	            occurrencedatefield = $("input[fieldId=22]");
              var occRules = occurrencedatefield.data('origrules') || occurrencedatefield.rules();
              var maxRule = occRules['xVal_maxError'];
	            var minRule = occRules['xVal_minError'];
              
              if (occurrencedatefield.data('origrules') === undefined) {
                occurrencedatefield.data('origrules', occRules);
              }
              var el = $('input[fieldId=23]').parent().find("input:hidden");
              if (el.length == 0) return;
              if (maxRule) {
                var newMaxRule = Object.assign({}, maxRule, { value: convertDate(maxRule.value, "UTC", $(el).val()) });
                occurrencedatefield.rules('add', { xVal_maxError: newMaxRule });
              }
              if (minRule) {
                var newMinRule = Object.assign({}, minRule, { value: convertDate(minRule.value, "UTC", $(el).val()) });
                occurrencedatefield.rules('add', { xVal_minError: newMinRule });
              }
              if (occurrencedatefield.val()) {
                window.setTimeout(function () { occurrencedatefield.valid() }, 100);
              }
	            if (el.attr('update-value') == 'true')
	                return;
	            
	            var format = occurrencedatefield.datepicker('option', 'dateFormat')||convertDateFormatToFlatpickr(occurrencedatefield.attr('format'));
	            try {
	                parsedValue = $.datepicker.parseDate(format, occurrencedatefield.val());
	            } catch (e) {
	                parsedValue = occurrencedatefield.datepicker('getDate');
	            }
	            if (parsedValue == undefined || parsedValue == null || isNaN(parsedValue))
	                parsedValue = occurrencedatefield.getDateValue();
	            if (parsedValue != null) {
	                var prevVal = $(el).attr('previousValue') || $(el).attr('previousval') || $(el).parent().find('input:first').val();
	                if (prevVal && dateSettings['disabled'] != true && prevVal != "" && prevVal != $(el).val()) {
	                    var convertedDate = convertDate(occurrencedatefield.getDateValue(), prevVal, $(el).val());
	                    $.confirmDialog($.dictionary.getValue("confirm_updateDate"), $.dictionary.getValue("title_updateDate"), function () {
	                            occurrencedatefield.setDateValue(convertedDate);
                              window.setTimeout(function () { occurrencedatefield.valid() }, 100);
	                        });
                    
	                    }

	                    
	                }
	                $(el).attr('previousValue', $(el).val());
	            });
              if (occurrencedatefield.val())
                window.setTimeout(function () { occurrencedatefield.valid() }, 100);
            
	        }
	    
    /*} catch (err) {
        
            	var dpError = $.dictionary.getValue('error_creatingDatepicker');
        $.errorDetailDialog(dpError, $.dictionary.getValue('error'), $.formatJavascriptErrorDetail(err.message, err.fileName, err.lineNumber, err.stack));
	}*/
}
